import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  DrawRewardResponse,
  RewardConfigurationType,
} from "@/api/backofficeRest/generated/model"
import { DrawReward } from "./drawReward"
import { IDrawReward } from "./drawReward.types"

export const DrawRewardParser: IParser<IDrawReward, DrawRewardResponse> = {
  toDomain: (data: DrawRewardResponse): IDrawReward => {
    try {
      const fuelPence = (type: RewardConfigurationType): number | null => {
        const value = (data.rewardConfiguration ?? []).find(
          (config) => config?.type === type,
        )?.value
        return value == null ? null : Number(value)
      }
      return new DrawReward(
        String(data.id),
        data.name,
        data.type,
        data.quantity,
        data.creditValuePence == null ? null : Number(data.creditValuePence),
        fuelPence(RewardConfigurationType.SINGLE_FUEL_PENCE),
        fuelPence(RewardConfigurationType.DUAL_FUEL_PENCE),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
